import React from 'react';
import { Input, DatePicker, Icon, Row, Col, Select, Tag } from 'antd';
import moment from 'moment';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

const { Option } = Select;
class Filters extends React.Component {

     
    handleChange = (option) => {
    debugger
       this.props.onChange("idCliente", option.key, "cliente", option.label[2].split('-')[0]);
   
      }

    render() {
        debugger
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    <Col className="gutter-row" sm={24} md={12} lg={8}>
                    <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.IdEstablecimiento ?
                                    { key: this.props.filter.IdEstablecimiento } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por establecimiento" />}
                            onChange={(option) => this.props.onChange("IdEstablecimiento", option.key, "establecimiento", option.label)}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            {this.props.establecimientos.map(item => ( 
                                <Option value={item.id} key={item.id} >{item.nombre}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                    <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.IdCaja ?
                                    { key: this.props.filter.IdCaja } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por caja" />}
                            onChange={(option) => this.props.onChange("IdCaja", option.key, "caja", option.label)}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                         {this.props.filter.cajas.map(item => ( 
                                <Option value={item.id} key={item.id} >{item.nombre}</Option>
                            ))}
                        </Select>

                    </Col>
           {/*          <Col className="gutter-row" sm={24} md={12} lg={3}>
                    <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.IdEmpleado ?
                                    { key: this.props.filter.IdEmpleado } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por responsable" />}
                            onChange={(option) => this.props.onChange("IdEmpleado", option.key, "empleado", option.label)}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                      {this.props.empleados.map(item => ( 
                                <Option value={item.id} key={item.id} >{item.nombre}</Option>
                            ))}
                        </Select>
                    </Col> */}

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.IdEstado ?
                                    { key: this.props.filter.IdEstado } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por estado" />}
                            onChange={(option) => this.props.onChange("IdEstado", option.key, "estado", option.label)}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            {this.props.estados.map(item => (
                                item.id != 1 ? <Option value={item.id} key={item.id} >{item.nombre}</Option>
                                :null
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

}

export default Filters;